import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const scriptUiNodeSpec: UiNodeSpec<'script'> = {
    requiredSockets: [ 'trigger' ],
    cfg: () => ({ controlValues: { scriptId: '' }, id: getUID(), kind: 'script', disabled: false }),
    controls: getNodeCfg => ({ scriptId: { cfg: { kind: 'scriptSelect' }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.scriptId } }),
    inputs: () => ({ trigger: { socket: 'event', label: 'Trigger' } }),
    kindLabel: 'Script',
    nodeCategory: 'other',
    outputs: () => ({ next: { socket: 'event', label: 'Next' } }),
    validator: (node, appletDesignVersionConfig) => {
        const validScriptIds = appletDesignVersionConfig.scripts.map(s => s.id);
        const errors: Record<string, string> = {};
        if (!node.controlValues.scriptId) {
            errors.scriptId = 'Script is required';
        }
        if (!validScriptIds.includes(node.controlValues.scriptId)) {
            errors.scriptId = 'Script is not a valid script';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
